module.exports = __webpack_public_path__ + "static/media/Clover_Legacy_188-1.3c65c78b.jpg";